import { useEffect, useState } from 'preact/hooks';
import { tenants, smtpConfig } from '../store/state';
import {
  loadTenants,
  activarTenant,
  desactivarTenant,
  loadSmtpConfig,
  guardarSmtpConfig,
  enviarSmtpPrueba,
} from '../store/actions/superadmin.actions';
import { Shell } from '../layout/Shell';
import { Icon } from '../components/Icon';

function fmtFecha(d: string) {
  return new Date(d).toLocaleDateString('es-AR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function SuperadminView() {
  const [testEmail, setTestEmail] = useState('');

  useEffect(() => {
    loadTenants();
    loadSmtpConfig();
  }, []);

  const onSmtpSubmit = (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    const data: Record<string, unknown> = {
      smtpHost: String(fd.get('smtpHost') || ''),
      smtpPort: fd.get('smtpPort') ? Number(fd.get('smtpPort')) : null,
      smtpSecure: fd.get('smtpSecure') === 'on',
      smtpUser: String(fd.get('smtpUser') || ''),
      smtpFrom: String(fd.get('smtpFrom') || ''),
    };
    const pass = String(fd.get('smtpPass') || '');
    if (pass) data.smtpPass = pass;
    guardarSmtpConfig(data);
  };

  return (
    <Shell tab="plataforma">
      <h2>Plataforma</h2>

      <h3 style={{ margin: '8px 0 8px' }}>Empresas</h3>
      {tenants.value.length ? (
        tenants.value.map((t) => (
          <div class="card" key={t.id}>
            <div class="row">
              <div>
                <strong>{t.nombre}</strong>
                <p class="muted" style={{ margin: '2px 0' }}>
                  {t.slug} · alta {fmtFecha(t.createdAt)}
                </p>
                {t.adminContacto && (
                  <p class="muted" style={{ margin: '2px 0' }}>
                    {t.adminContacto.nombre} · {t.adminContacto.email}
                  </p>
                )}
                <p class="muted" style={{ margin: '2px 0' }}>
                  {t.totalUsuarios} usuario(s) · {t.totalClientes} cliente(s)
                </p>
              </div>
              <span class={'badge ' + (t.activo ? 'al_dia' : 'vencida')}>
                {t.activo ? 'Activa' : 'Pendiente / inactiva'}
              </span>
            </div>
            <button
              class={t.activo ? 'danger-outline' : 'primary'}
              style={{ marginTop: 8 }}
              onClick={() =>
                t.activo ? desactivarTenant(t.id, t.nombre) : activarTenant(t.id, t.nombre)
              }
            >
              <Icon name={t.activo ? 'ban' : 'check'} size={14} />
              {t.activo ? 'Desactivar' : 'Activar'}
            </button>
          </div>
        ))
      ) : (
        <div class="empty">
          <Icon name="building-2" />
          <p>Todavía no hay empresas registradas.</p>
        </div>
      )}

      <h3 style={{ margin: '20px 0 8px' }}>Configuración de email (SMTP)</h3>
      <div class="card">
        <p class="muted" style={{ margin: '0 0 12px' }}>
          {smtpConfig.value
            ? `Fuente actual: ${smtpConfig.value.origen}.`
            : 'Cargando...'}
        </p>
        <form class="form-desktop" onSubmit={onSmtpSubmit}>
          <label>Host</label>
          <input name="smtpHost" defaultValue={smtpConfig.value?.smtpHost || ''} placeholder="smtp.ejemplo.com" />
          <label>Puerto</label>
          <input name="smtpPort" type="number" defaultValue={smtpConfig.value?.smtpPort || ''} placeholder="587" />
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input
              name="smtpSecure"
              type="checkbox"
              style={{ width: 'auto' }}
              defaultChecked={smtpConfig.value?.smtpSecure || false}
            />
            Conexión segura (TLS)
          </label>
          <label>Usuario</label>
          <input name="smtpUser" defaultValue={smtpConfig.value?.smtpUser || ''} />
          <label>Contraseña</label>
          <input
            name="smtpPass"
            type="password"
            placeholder={smtpConfig.value?.tieneContrasena ? 'Sin cambios (ya hay una guardada)' : ''}
          />
          <label>Remitente (From)</label>
          <input name="smtpFrom" defaultValue={smtpConfig.value?.smtpFrom || ''} placeholder="alertas@tuempresa.com" />
          <button class="primary" type="submit">
            Guardar configuración
          </button>
        </form>

        <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid var(--border)' }}>
          <label>Enviar email de prueba</label>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              type="email"
              placeholder="tu@email.com"
              value={testEmail}
              onInput={(e) => setTestEmail((e.target as HTMLInputElement).value)}
            />
            <button
              class="secondary"
              style={{ width: 'auto', padding: '0 16px' }}
              disabled={!testEmail}
              onClick={() => enviarSmtpPrueba(testEmail)}
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </Shell>
  );
}
